import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as moment from 'moment';
import './styles.css';
let intervalTemp;
class Timer extends Component {
  constructor(props){
    super(props);
    this.state = {
      currentChallenge: {},
      days: 0,
      hours: 0,
      min: 0,
      sec: 0,
    }
  }
  componentWillMount(){
    let challenge = this.props.events.data.sort((a, b) => {
      return a.date.toDate().getTime() - b.date.toDate().getTime();
    })[3];
    challenge.date = moment('02/07/2018', 'DD/MM/YYYY');
    challenge.location = 'ADIDAS HQ';
    this.setState({currentChallenge: challenge}, () => {
      this.setTimer();
      intervalTemp = setInterval(() => {
        this.setTimer()
      }, 1000)
    });
  }

  componentWillUnmount(){
    clearInterval(intervalTemp)
  }

  setTimer(){
    let mm = this.state.currentChallenge.date.toDate().getTime() - new Date().getTime();
    let dur = moment.duration(mm);
    this.setState({days: dur.days(), hours: parseInt(dur.asHours(), 10), min: dur.minutes(), sec: dur.seconds()});
  }

  render(){
    return (
      <div className="timer-container">
        <div className="timer-counter">{`
          ${this.state.hours > 9 ? this.state.hours : '0'+this.state.hours}:${this.state.min > 9 ? this.state.min : '0'+this.state.min}:${this.state.sec > 9 ? this.state.sec : '0'+this.state.sec}
          `}</div>
        <div className="timer-text">
          next hackathon <span className="color-red">{this.state.currentChallenge.location}</span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    events: state.challenges,
  };
}

export default connect(mapStateToProps)(Timer);



// WEBPACK FOOTER //
// ./src/components/Timer/Timer.js